import React, {useRef} from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";

import GroheCartHeader from "./groheCartHeader";
import MaterialSpinner from "../../../ui/materialSpinner";
import GroheCartContent from "./groheCartContent";
import GroheCartFooter from "./groheCartFooter";
import GroheCartStickyFooter from "./groheCartStickyFooter";
import {setLookOpened, setLookOverlayOpened, setLookPageOpened} from "../../../../actions/lookFunctions";
import {ROUTES} from "../../../../routes";
import {LOOK_OVERLAYS} from "../../core/constants";
import WithCartAnimationsChecker from "../../hocs/withCartAnimationsChecker";
import Analytics from "../../../../analytics";
import {getAnalyticsEcommerceValues} from "../../../../analyticsEcommerceParams";
import {IS_DEALER_FLOW} from "../../../../config";

const GroheCart = (props) => {

  const {visualizersLoadedLength, isMobile, setLookPageOpened, userIsLoggedIn, history, setLookOpened,
    fabricatorSettings, isPhoneNumberValidated, setLookOverlayOpened} = props;
  const gcRef = useRef();

  const cartFooterCheckoutClick = (shouldOpenLeadCapturePopup) => {

    const {currency, value, items} = getAnalyticsEcommerceValues();
    Analytics.sendEcommerceEvent("begin_checkout", {currency, value, items});

    if (shouldOpenLeadCapturePopup) {
      setLookOverlayOpened(LOOK_OVERLAYS.leadCapture);
      return false
    }
    if (userIsLoggedIn) {
      if (fabricatorSettings.twoFA && !isPhoneNumberValidated) {
        history.push(ROUTES.cartTwoFAVerify);
      } else if (fabricatorSettings.hasPaymentGateway) {
        history.push(ROUTES.cartBilling);
      } else if (IS_DEALER_FLOW) {
        history.push(ROUTES.cartShipping);
      } else {
        history.push(ROUTES.cartConfirm);
      }
    } else {
      history.push(isMobile ? ROUTES.cartRegister : ROUTES.cartLogin)
    }
  }

  return (
    <WithCartAnimationsChecker>
      {(leadPopupWasOpened, shouldOpenLeadCapturePopup) => {

        const stickyFooterButtons = [
          {
            translate: "buttons.back",
            classes: "look-button--secondary",
            onClick: () => {
              setLookPageOpened("");
              setLookOpened(null);
              history.push(ROUTES.home);
            }
          },
          {
            translate: "buttons.checkout",
            classes: "look-button--blue gc-sticky__button--60",
            onClick: () => cartFooterCheckoutClick(shouldOpenLeadCapturePopup)
          }
        ];

        return (
          <div className="gc" ref={gcRef}>
            <div className="gc-body">
              <GroheCartHeader/>
              {!visualizersLoadedLength || (shouldOpenLeadCapturePopup && !leadPopupWasOpened) ? (
                <div className="gc-main">
                  <MaterialSpinner/>
                </div>
              ) : <GroheCartContent/>}
              <GroheCartFooter cartFooterCheckoutClick={() => cartFooterCheckoutClick(shouldOpenLeadCapturePopup)}/>
              {isMobile ? <div className="gc-spacer"/> : null}
            </div>
            {isMobile ? <GroheCartStickyFooter stickyFooterButtons={stickyFooterButtons}/> : null}
          </div>
        )
      }}
    </WithCartAnimationsChecker>
  )
};

const mapStateToProps = (store) => {
  const {visualizersLoaded, isMobile} = store.serverState;
  const {userIsLoggedIn, isPhoneNumberValidated} = store.userState;
  const {settings} = store.fabricatorState;

  return {
    isMobile,
    visualizersLoadedLength: visualizersLoaded.length,
    userIsLoggedIn,
    isPhoneNumberValidated,
    fabricatorSettings: settings,
  };
};

const mapDispatchToProps = {
  setLookPageOpened,
  setLookOpened,
  setLookOverlayOpened,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GroheCart)
)
